import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Navbar.css";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io";
import logo from "../assets/logo1.png";
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setMenuOpen((open) => !open);

  React.useEffect(() => setMenuOpen(false), [location]);
  const mailtoLink = `mailto:kav@kasibhatlaws.in?subject=Hello&body=This%20is%20a%20test%20email`;

  const phoneNumber = "9702004242"; // Replace with your number
  return (
    <>
      <div className="topbar">
        <div className="topbar-contact">
          <div className="contact-item">
            <FaPhoneAlt className="contact-icon" size={14} />
            <span>9702004242 / 9010903484</span>
          </div>
          <div className="contact-item">
            <a href={mailtoLink}>
              <MdEmail className="contact-icon" size={20} />
              <span>kav@kasibhatlaws.in</span>
            </a>
          </div>
          <div className="contact-item">
            <a
              href={`https://wa.me/${phoneNumber}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IoLogoWhatsapp
                className="contact-icon"
                size={22}
                color="green"
              />
              <span>Live Chat</span>
            </a>
          </div>
        </div>
      </div>
      <nav className="navbar">
        <NavLink to="/">
          <img
            src={logo}
            alt="logo"
            style={{ width: "150px", height: "100px" }}
          />
        </NavLink>

        <div className={`navbar-links ${menuOpen ? "open" : ""}`}>
          <NavLink to="/" className="nav-link" activeClassName="active">
            Home
          </NavLink>
          <NavLink to="/about" className="nav-link" activeClassName="active">
            About Us
          </NavLink>
          {/*    <Link to="/services">Our Services</Link> */}
          <NavLink
            to="/practice-areas"
            className="nav-link"
            activeClassName="active"
          >
            Our Practice Areas
          </NavLink>
          {/* <Link to="/team">Our Team</Link> */}
          <NavLink to="/contact" className="nav-link" activeClassName="active">
            Contact Us
          </NavLink>
        </div>

        <div
          className={`menu-icon ${menuOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <div />
          <div />
          <div />
        </div>
      </nav>
    </>
  );
};

export default Navbar;
